'use client';

import { c as _c } from "react/compiler-runtime";
import { LazyMotion } from 'motion/react';
const features = () => import('@/lib/motion-features.js').then(res => res.default);
export function MotionProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <LazyMotion features={features} strict={true}>{children}</LazyMotion>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}